module.exports = __webpack_public_path__ + "media/npc_dota_hero_magnataur.5e247e18.webm";